import type { RespostasEtapa1Candidato } from '../../../models';

interface EtapaSobreIAProps {
  respostas: RespostasEtapa1Candidato;
  onChange: (campo: keyof RespostasEtapa1Candidato, valor: string) => void;
}

export default function EtapaSobreIA({ respostas, onChange }: EtapaSobreIAProps) {
  return (
    <>
      <span className="mb-3 inline-flex items-center rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-700">
        Sobre IA
      </span>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Como você usa IA no seu processo de desenvolvimento?</h2>
      <div className="space-y-5">
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">
            Você organiza o seu processo de desenvolvimento com ferramentas de IA em etapas bem definidas? *
          </label>
          <textarea
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            rows={3}
            value={respostas.sobreIaEtapas ?? ''}
            onChange={(e) => onChange('sobreIaEtapas', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">
            Quais são as etapas que você divide, quando decide incluir a IA em seu processo de desenvolvimento? *
          </label>
          <textarea
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            rows={3}
            value={respostas.sobreIaProcesso ?? ''}
            onChange={(e) => onChange('sobreIaProcesso', e.target.value)}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-semibold text-gray-700">
            O que você faz para garantir a qualidade da solução que você gera utilizando IA antes de liberar para ser
            utilizada? *
          </label>
          <textarea
            className="w-full rounded-xl border-2 border-gray-100 p-3 focus:border-indigo-400 focus:outline-none"
            rows={3}
            value={respostas.sobreIaQualidade ?? ''}
            onChange={(e) => onChange('sobreIaQualidade', e.target.value)}
          />
        </div>
      </div>
    </>
  );
}
